import { Client, IFrame, IMessage } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { webSocketStore } from 'store/notification';
import { action } from 'mobx';
import userStore from 'store/user';

// const userStore = instantiate<UserStore>(UserStore as any);

export const stompClient = new Client({
  webSocketFactory: () => {
    return new SockJS(`/api/endpoint-websocket`, null, {
      transports: 'websocket',
    });
  },
  onConnect: () => {
    action(() => {
      webSocketStore.approvedByMeCount = '';
    })();
    stompClient.subscribe(
      `/user/${userStore.userProfile.username}/ws/popup-info/new-transaction`,
      (message: IMessage) => {
        action(() => {
          webSocketStore.approvedByMeCount = message.body || '';
        })();
      },
    );
    stompClient.publish({
      destination: '/ws/topup/query',
      body: JSON.stringify({ userId: userStore.userProfile.username }),
    });
  },
  onDisconnect: (receipt: IFrame) => {
    console.log('disconnected', receipt);
    action(() => {
      webSocketStore.approvedByMeCount = '';
    })();
  },
  heartbeatIncoming: 5000,
  heartbeatOutgoing: 5000,
});
process.env.MODE === 'development' ? ((window as any).stompClient = stompClient) : void 0;
// stompClient.activate();
